import React, { useState } from 'react';
import './ClassroomEnhanced.css';

const DEFAULT_BREAKS = [
  { emoji: '🕺', title: 'Dance Freeze', prompt: 'Dance until the music stops!' },
  { emoji: '🤸', title: 'Stretch Quest', prompt: 'Reach for the stars and wiggle fingers.' },
  { emoji: '🧘', title: 'Calm Cloud', prompt: 'Close eyes, inhale for 4, exhale for 4.' },
  { emoji: '⚡', title: 'Power Pose', prompt: 'Hold your hero pose for 10 seconds.' },
  { emoji: '🎵', title: 'Hum Jam', prompt: 'Hum your favorite game tune for 15 seconds.' }
];

const BrainBreakSpinner = ({ breaks = DEFAULT_BREAKS }) => {
  const [current, setCurrent] = useState(null);
  const [isSpinning, setIsSpinning] = useState(false);

  const spin = () => {
    setIsSpinning(true);
    const randomBreak = breaks[Math.floor(Math.random() * breaks.length)];
    setTimeout(() => {
      setCurrent(randomBreak);
      setIsSpinning(false);
    }, 1200);
  };

  return (
    <section className="brain-break">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Energy boosts</p>
          <h3>Brain break spinner</h3>
        </div>
        <button type="button" className="spin-btn" onClick={spin} disabled={isSpinning}>
          {isSpinning ? 'Spinning...' : 'Spin 🎡'}
        </button>
      </div>

      {current ? (
        <div className="brain-break-card">
          <span className="break-emoji" aria-hidden="true">{current.emoji}</span>
          <div>
            <h4>{current.title}</h4>
            <p>{current.prompt}</p>
          </div>
        </div>
      ) : (
        <p className="brain-break-placeholder">Spin the wheel to pick a quick brain break! 🌈</p>
      )}
    </section>
  );
};

export default BrainBreakSpinner;
